import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Cart = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { d: "M0 3.75C0 3.06.56 2.5 1.25 2.5h3.333a1.25 1.25 0 0 1 1.192.874L8 10.417h7.986l1.584-4.576a1.25 1.25 0 1 1 2.362.818l-1.875 5.417a1.25 1.25 0 0 1-1.181.84H7.083a1.25 1.25 0 0 1-1.192-.873L3.667 5H1.25C.56 5 0 4.44 0 3.75M8.125 17.5a1.458 1.458 0 1 0 0-2.917 1.458 1.458 0 0 0 0 2.917m7.917 0a1.458 1.458 0 1 0 0-2.917 1.458 1.458 0 0 0 0 2.917" }), _jsx("path", { d: "M10 6.667a1.25 1.25 0 1 0 0 2.5h4.167a1.25 1.25 0 0 0 0-2.5z" })] }));
});
Cart.displayName = 'Cart';
Cart.__iconComponentType = 'standard';
export default Cart;
//# sourceMappingURL=Cart.js.map